import { route } from './../../../routes/web';
import { setMessage } from './../../../actions/setMessage';
import { request } from './../../../functions/request';
import { ParseError } from './../../../functions/error-parse';
import { map } from 'underscore';
import { mapSettingsMap } from '../../lending/sections';
import { landingAPI } from '../../../api';

export const front_options_request_invalid = 'front_options_request_invalid';
export const front_options_request_send = 'front_options_request_send';
export const front_options_request_valid = 'front_options_request_valid';
export const change_app_setting_sidebar = 'change_app_setting_sidebar';
export const change_app_setting_content = 'change_app_setting_content';
export const change_app_setting_right_modal = 'change_app_setting_right_modal';
export const change_app_setting_point_modal = 'change_app_setting_point_modal';
export const change_app_setting_content_primary =
    'change_app_setting_content_primary';
export const change_app_setting_main_page = 'change_app_setting_main_page';
export const change_app_snapshot_main_page = 'change_app_snapshot_main_page';
export const discard_snapshot_settings = 'discard_snapshot_settings';

export function frontOptionsRequestInvalid() {
    return {
        type: front_options_request_invalid,
    };
}

export function frontOptionsRequestSend() {
    return {
        type: front_options_request_send,
    };
}

export function frontOptionsRequestValid(data) {
    return {
        type: front_options_request_valid,
        data: data,
    };
}

export function fetchFrontOptions(data, success) {
    return function (dispatch) {
        dispatch(frontOptionsRequestSend());

        request(
            route.admin.front.edit,
            data,
            (data) => {
                if (data.success) {
                    dispatch(frontOptionsRequestValid(data.user_data));
                    if (typeof success === 'function') success(data);
                    dispatch(setMessage('Сохранено'));
                } else {
                    if (data.msg) {
                        dispatch(setMessage(ParseError(data.msg), 'error'));
                    } else {
                        dispatch(setMessage('Неверные данные', 'error'));
                    }
                    dispatch(frontOptionsRequestInvalid());
                }
            },
            (error) => {
                dispatch(frontOptionsRequestInvalid());
            }
        );
    };
}

export function fetchMainPageOptions(settings, success) {
    return (dispatch) => {
        dispatch(
            fetchFrontOptions(
                {
                    data: map(settings, (setting) => {
                        return map(setting, (item) => {
                            return mapSettingsMap[item.type]?.(item) || setting;
                        });
                    }),
                    name: 'mainPage',
                },
                () => {
                    if (typeof success === 'function') success();
                }
            )
        );
    };
}

export function fetchTypesOptions(data, success) {
    return (dispatch) => {
        dispatch(
            fetchFrontOptions(
                {
                    data,
                    name: 'types',
                },
                () => {
                    if (typeof success === 'function') success();
                    dispatch(landingAPI.util.invalidateTags(['ACTIVE_TYPES']));
                }
            )
        );
    };
}
